import Vue from "vue";
import {
  message,
  Modal
} from "ant-design-vue";

const namespaced = true;

function initialState() {
  return {
    users: {}
  };
}

const state = {
  users: initialState().users
};

const mutations = {
  SET_USER: (state, user) => {
    Vue.set(state.users, user.id, user);
  },
  UNSET_USER: (state, id) => {
    Vue.delete(state.users, id);
  }
};

const actions = {
  create: ({
    commit
  }, user) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/admin/user`, {
          user: user
        })
        .then(response => {
          commit("SET_USER", response.data.user);
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/user/${id}`)
        .then(response => {
          commit("SET_USER", response.data.user);
          resolve(response.data.user);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/user`)
        .then(response => {
          for (const user of response.data.users) {
            commit("SET_USER", user);
          }
          resolve();
        })
        .catch(error => {
          // Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, user) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/admin/user/${user.id}`, {
          user: user
        })
        .then(response => {
          commit("SET_USER", response.data.user);
          resolve(response.data.user);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    commit
  }, id) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`/admin/user/${id}`)
        .then(response => {
          commit("UNSET_USER", id);
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.users;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.users);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};